import { createGlobalStyle } from "styled-components";

const FilterStyle = createGlobalStyle`
    .unchecked{
        border: 1px solid #FFFFFF;
        box-sizing: border-box;
        border-radius: 2px;
        width: 15px;
        height: 15px;
    }
    .filter-count{
        width: 15px;
        height: 15px;
        background: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        right: 0;
        border: 1px solid #000;
    }
    .checked{
        border: 1px solid #BDFF00;
        box-sizing: border-box;
        border-radius: 2px;
        width: 15px;
        height: 15px;
        ::before {
            position: absolute;
            left: 0;
            top: 33%;
            height: 50%;
            width: 1px;
            background-color: #BDFF00;
            content: "";
            transform: translateX(5px) rotate(-45deg);
            transform-origin: left bottom;
        }
        ::after{
            position: absolute;
            left: 0;
            bottom: 3px;
            height: 1px;
            width: 75%;
            background-color: #BDFF00;
            content: "";
            -webkit-transform: translateX(5px) rotate(-45deg);
            transform-origin: left bottom;
        }
    }
`;

export default FilterStyle;